module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/selling-medium-828edfd7aafcd03f3ca3ec5be3263f41.svg";